export const redisConfig =
  process.env.BUILD_ENV === 'prod' ? 'avatar-cache.prod.goibibo.com' : '127.0.0.1';
export const redisPort = '6379';

export const aerospikeIp =
  // '10.30.40.106';
  process.env.BUILD_ENV === 'prod' ? '10.30.40.106' : '127.0.0.1';

export const aerospikePort = 3000;

export const aerospikeNamespaceForVoyager =
  // 'stencil';
  process.env.BUILD_ENV === 'prod' ? 'stencil' : 'test';

export const aerospikeNamespaceForHotels =
  // 'stencil';
  process.env.BUILD_ENV === 'prod' ? 'stencil' : 'test';
